import React, { useEffect } from 'react'
import { useState } from 'react'
import { Drawer, Form, Row, Col ,Button, Space } from "antd"
import { MyInput } from '../Forms';
import { apiCalls } from '../../shared/Apis';

const AddServiceDrawer = ({visible, onClose, edititem, getServiceApi}) => {

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    useEffect(()=>{
        if(visible && edititem){
            form.setFieldsValue({
                ...edititem,
                name:edititem?.name
            })
        } else{
            form.resetFields()
        }

    },[visible, edititem])

    const updateCreateApi = async (formData) => {
        setLoading(true);
        try {
            const result = await apiCalls.addServiceapi.updateCreateApi({...formData,id:edititem?.id});
            setLoading(false);
            getServiceApi();
            if (result) {
                form.resetFields();
                onClose();
            }
        } catch (error) {
            console.error('Error updating/creating service:', error);
            setLoading(false);
        }
    };
    

    const onFinish = async () => {
        try {
            const formData = await form.validateFields();
            updateCreateApi(formData);
        } catch (error) {
            console.error("Form validation error:", error);
        }
    };



    const closeDrawer = () => {
        form.resetFields(); 
        onClose();
    };

  return (
    <Drawer
        title={edititem?'Edit Service':'Add Service'}
        onClose={closeDrawer}
        className="drawer"
        open={visible}
        width={500}
        footer={
        <Space className="w-100 right">
            <Button 
                onClick={closeDrawer}
                className="btncancel"
            >
                Cancel
            </Button>
            <Button  
                block
                className='btnsave bg-brand'
                type="primary"
                htmlType="submit"
                loading={loading}
                onClick={()=> form.submit()}
            >
                {edititem? 'Update' : 'Save'}
            </Button>
        </Space>
    }
>
    <Form
        form={form}
        layout="vertical"
        initialValues={true}
        onFinish={onFinish}
        requiredMark={false}
    >
        <Row gutter={16} justify={'center'}>
            <Col lg={{span: 24}} md={{span: 24}} xs={{span: 24}} sm={{span: 24}}>
                <MyInput
                    label= 'Service'
                    name="name" 
                    size={'large'}
                    required
                    message='Please enter service'
                />
            </Col>
        </Row>
    </Form>
</Drawer>
  )
}

export {AddServiceDrawer}